var render = function render(){var _vm=this,_c=_vm._self._c;return _c('sf-data-table',{ref:"table",attrs:{"columns":_vm.columns,"rows":_vm.rows}})
}
var staticRenderFns = []

export { render, staticRenderFns }